import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AbstractControl, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {SelectOption} from '@xmedical/core';
import {XmedicalUiModule} from '@xmedical/ui';
import {Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

@Component({
    selector: 'xcs-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.scss'],
    imports: [
      ReactiveFormsModule,
      MatAutocompleteModule,
      MatButtonModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      XmedicalUiModule,
    ],
})
export class ContactFormComponent implements OnInit, OnDestroy {

  @Input() controlFormGroup: AbstractControl;
  @Input() index: number;
  @Input() deleteEnabled = true;
  @Output() delete: EventEmitter<number> = new EventEmitter<number>();
  types: SelectOption[] = [
    {value: 0, text: 'Home'},
    {value: 1, text: 'Work'},
    {value: 2, text: 'Cell'},
    {value: 3, text: 'Fax'},
    {value: 4, text: 'Custom'},
  ];
  formGroup: UntypedFormGroup;
  displayTypes: string[] = [];
  internalFormControl = new UntypedFormControl();
  private labelChangeSubscription: Subscription;

  constructor() {
  }

  get showDelete(): boolean {
    return this.deleteEnabled && this.delete.observers.length > 0;
  }

  ngOnInit(): void {
    if (!this.controlFormGroup) {
      console.error('contact-form: controlFormGroup is null or undefined!');
      return;
    }

    this.formGroup = this.controlFormGroup as UntypedFormGroup;
    this.displayTypes = this.types.map(type => type.text);
    const initialValue = this.controlFormGroup.value;
    const initialLabel = this.types.find(t => t.value === initialValue.type);

    this.labelChangeSubscription = this.internalFormControl.valueChanges.pipe(debounceTime(250), distinctUntilChanged()).subscribe(value => {
      const mappedType = this.types.find(t => t.text.toLowerCase() === value.toLowerCase());
      if (mappedType) {
        this.controlFormGroup.get('type').setValue(mappedType.value);
        this.controlFormGroup.get('label').setValue(mappedType.text);
      } else {
        this.controlFormGroup.get('type').setValue(4);
        this.controlFormGroup.get('label').setValue(value);
      }
      // Mark hidden fields as touched when the visible field changes
      this.controlFormGroup.get('type').markAsTouched();
      this.controlFormGroup.get('label').markAsTouched();
    });
    if (initialLabel) {
      this.internalFormControl.setValue(initialLabel.text);
    }
  }

  ngOnDestroy(): void {
    this.labelChangeSubscription?.unsubscribe();
  }

  deleteItem() {
    this.delete.emit(this.index);
  }

}
